// extracted by mini-css-extract-plugin
export default {"panelCard":"AdvocateCard_panelCard__xcD+Q","advocateProfileImg":"AdvocateCard_advocateProfileImg__Pwe4q","panelCardContent":"AdvocateCard_panelCardContent__a1TOo"};